'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$156() {
  this.c30 = null;
  this.c31 = false;
}
export { $c_Lpresto_types$$anon$156 as $c_Lpresto_types$$anon$156 };
$p = $c_Lpresto_types$$anon$156.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$156;
/** @constructor */
function $h_Lpresto_types$$anon$156() {
}
export { $h_Lpresto_types$$anon$156 as $h_Lpresto_types$$anon$156 };
$h_Lpresto_types$$anon$156.prototype = $p;
$p.P = (function() {
  if ((!this.c31)) {
    this.c30 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c31 = true;
  }
  return this.c30;
});
var $d_Lpresto_types$$anon$156 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$156, "presto.types$$anon$156", ({
  Yd: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$156 as $d_Lpresto_types$$anon$156 };
//# sourceMappingURL=presto.types$$anon$156.js.map
